import React from 'react'
import classnames from 'classnames'

import SidebarHeader from './sidebar-header'
import SidebarItem from './sidebar-item'
import { sidebarContent, sidebarHeaderContent } from './sidebar-content'
import { roleType, hasPermission } from '../../../core/auth0'
import styles from '../../styles/modules/sidebar/sidebar.module.scss'

interface Props {
  selected: string
  isOpen: boolean
  role: roleType
}

const Sidebar: React.FC<Props> = props => (
  <aside
    className={classnames({
      [styles.container]: true,
      [styles.open]: props.isOpen,
    })}
  >
    <SidebarHeader content={sidebarHeaderContent} />
    <nav className={styles.navigation}>
      {sidebarContent.map(item => {
        // 基本的なロールチェック
        if (!item.allowedAccessRolls?.includes(props.role)) {
          return null
        }
        
        // 権限チェック
        if (item.requiredPermission && !hasPermission(props.role, item.requiredPermission)) {
          return null
        }
        
        return (
          <SidebarItem
            key={item.id}
            role={props.role}
            content={item}
            selected={props.selected}
            isSubMenu={false}
          />
        )
      })}
    </nav>
  </aside>
)

export default Sidebar
